export const PRIORITY_OPTIONS = [
  { label: "Essential", value: "essential" },
  { label: "Aware", value: "aware" },
  { label: "Flexible", value: "flexible" }
];

export const PREP_TIME_OPTIONS = [
  { label: "None", value: 0 },
  { label: "5 min", value: 5 },
  { label: "10 min", value: 10 },
  { label: "15 min", value: 15 },
  { label: "30 min", value: 30 },
  { label: "45 min", value: 45 },
  { label: "1 hr", value: 60 }
];

export const NOTIFICATION_OPTIONS = [
  { label: "None", value: "none" },
  { label: "At time of event", value: "0" },
  { label: "5 minutes before", value: "5" },
  { label: "10 minutes before", value: "10" },
  { label: "15 minutes before", value: "15" },
  { label: "30 minutes before", value: "30" },
  { label: "1 hour before", value: "60" }
];

// keep REMINDER_OPTIONS for older imports (alias)
export const REMINDER_OPTIONS = NOTIFICATION_OPTIONS;

export const EVENT_TAGS = [
  { label: "Essential", value: "essential" },
  { label: "Aware", value: "aware" },
  { label: "Flexible", value: "flexible" }
];

export const SORT_OPTIONS = [
  { label: "Date (soonest)", value: "date_asc" },
  { label: "Date (latest)", value: "date_desc" },
  { label: "Title (A–Z)", value: "title_asc" },
  { label: "Title (Z–A)", value: "title_desc" }
];

export const WEEKDAY_ABBREVIATIONS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const DEFAULT_EVENT_DURATION_MINUTES = 30;
